import { useEffect, useState } from "react";
import { ChartBar } from "@phosphor-icons/react";
import { teleproApi } from "../../lib/teleproApi";

// VAGUE 42 — refus par motif + leads chauds (30 j).
const HOT_LABELS = { premium: "Premium", premium_ia: "Premium IA", site_web: "Site internet", unspecified_interest: "Intéressé (offre non précisée)" };

export function QualificationBreakdown({ data, testid }) {
  const max = Math.max(1, ...data.refusals.map((r) => r.count));
  return (
    <div className="grid sm:grid-cols-2 gap-4" data-testid={testid}>
      <div>
        <div className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground mb-2">
          Refus par motif · {data.refusals_total}
        </div>
        <ul className="space-y-1.5">
          {data.refusals.map((r) => (
            <li key={r.reason} className="text-xs" data-testid={`${testid}-refusal-${r.reason}`}>
              <div className="flex justify-between gap-2"><span>{r.label}</span><span className="font-mono font-bold">{r.count}</span></div>
              <div className="h-1.5 bg-muted rounded-full overflow-hidden mt-0.5">
                <div className="h-full bg-secondary" style={{ width: `${(r.count / max) * 100}%` }}/>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <div className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground mb-2">Leads chauds</div>
        <ul className="space-y-1.5">
          {Object.entries(HOT_LABELS).map(([k, label]) => (
            <li key={k} className="flex justify-between text-xs border-b border-border/60 pb-1" data-testid={`${testid}-hot-${k}`}>
              <span>{label}</span><span className="font-mono font-bold text-primary">{data.hot_leads[k] || 0}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default function TeleproQualificationCard() {
  const [data, setData] = useState(null);
  useEffect(() => {
    teleproApi.get("/me/qualification-stats?days=30").then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return null;
  return (
    <section className="bg-card border border-border rounded-sm p-4 sm:p-5" data-testid="telepro-qualification-card">
      <div className="flex items-center gap-2 mb-3">
        <ChartBar size={16} weight="duotone" className="text-primary"/>
        <h3 className="font-display text-base font-medium">Mes refus et leads chauds — 30 derniers jours</h3>
      </div>
      <QualificationBreakdown data={data} testid="telepro-qualif"/>
    </section>
  );
}
